



















import Vue from "vue";
import Rates from "@/components/Molecules/Rates/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import CompanyLogo from "@/components/Atoms/CompanyLogo/index.vue";

import { Data, Methods, Computed, Props } from "./types";
import { PropType } from "vue/types/umd";

const SIZE = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
};

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CompanyHeading",
  components: {
    Rates,
    Heading,
    CompanyLogo
  },
  props: {
    company: {
      type: Object as PropType<Props["company"]>,
      required: true
    },
    showRating: {
      type: Boolean as PropType<Props["showRating"]>,
      default: false
    },
    size: {
      type: String as PropType<Props["size"]>,
      default: "medium",
      validator(val) {
        return Object.values(SIZE).includes(val);
      }
    }
  },
  computed: {
    logoSize() {
      if (this.size === SIZE.LARGE) return "30";
      else if (this.size === SIZE.MEDIUM) return "24";
      return "20";
    },
    logoStyle() {
      return {
        width: `${this.logoSize}px`,
        height: `${this.logoSize}px`
      };
    },
    companyHeadingClasses() {
      return ["companyHeading", `companyHeading--size--${this.size}`];
    }
  }
});
